<template>
  <topbar
    :titulo="$t('ACADEMICO.RELATORIOS_SITUACAO_CONTRATO')"
    :subtitulo="$t('ACADEMICO.RELATORIOS_SITUACAO_CONTRATO_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  />
</template>
<script>
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO.ACADEMICO') },
        { titulo: this.$t('ACADEMICO.RELATORIOS') },
        { titulo: this.$t('ACADEMICO.RELATORIOS_SITUACAO_CONTRATO') },
      ],
    };
  },
  methods: {},
};
</script>
